import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface CustomLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  htmlFor: string;
  label: ReactNode | string;
}

export const CustomLabel = ({
  htmlFor,
  label,
  className,
  ...props
}: CustomLabelProps) => {
  return (
    <label
      htmlFor={htmlFor}
      data-slot="form-label"
      className={cn("text-sm font-normal !text-gray-950", className)}
      {...props}
    >
      {label}
    </label>
  );
};
